import React from "react";

import { serverUrl } from "../../config";

import GridItem from "../../partials/gridItem";
import { useNavigate } from "react-router-dom";

export default function GalleryItem(props) {
  const navigate = useNavigate();

  return (
    <GridItem
      xs={12} 
      sm={6} 
      md={6}
      itemClass="gallery"
      bundle={props.item?.bundle}
      nid={props.item?.nid}
      title={props.item?.title}
      category_label={props.item?.category_labels}
      // field_body={props.item?.summary ? props.item?.summary : props.item?.body}
      created={props.item?.created}
      hasImg={true}
      imgSrc={`${serverUrl}${props.item.field_featured_image}`}
      cardAction={true}
      cardActionCallBack={() => navigate(`/galleries/${props.item?.nid}`)}
      contentType={props.contentType}
      shareEnabled
      route={'galleries'}
      field_access_token={props.item.field_access_token}
      sharePrompt={`This is a public link that enables you to share the image gallery with your client, no login required.`}
      />
  )
}